export const PasswordChange = {
  Title: 'Zmena hesla',
  CurrentPassword: 'Aktuálne heslo',
  NewPassword: 'Nové heslo',
  ConfirmNewPassword: 'Potvrďte nové heslo',
  Submit: 'Zmeniť heslo',
  PasswordChanged: 'Heslo zmenené',
};
